<template>
  <div id="loan">
    <loading v-if="loadingRender"></loading>
    <panel
      v-if="$GetIsAnbohSaz() == 'false'"
      Title="لیست تسهیلات"
      Des="از طریق این فرم می توانید لیست تسهیلات های خود را مشاهده واز امکانات عملیات های پرداخت قسط و کاردکس تسهیلات استتفاده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <div class="row">
      <div class="col-md-8 col-12 mt-4">
        <div v-for="list in CartValue" :key="list.Id" class="row border-right border-success Netpa-Shadow-2 bg-white p-1 mt-2 px-4" style="border-right: solid 4px !important">
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2">
            <span class="text-secondary">{{ $GetIsAnbohSaz() == "false" ? "نام تسهیلات" : "نام قرارداد" }}: </span> <br />
            <small class="no-wrap">{{ list.desNoe }}</small>
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">{{ $GetIsAnbohSaz() == "false" ? "شماره تسهیلات" : "شماره قرارداد" }}</span
            ><br />
            <small class="no-wrap" dir="rtl">{{ list.vCode }}</small>
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">مبلغ قسط</span><br />
            <input v-if="list.sumMabMoavaghe == 0" class="form-control 3ragham text-center mt-2" style="font-size: 14px !important" v-model="list.mablaghGhestVam" />
            <input v-else class="form-control 3ragham text-center mt-2" style="font-size: 14px !important" v-model="list.sumMabMoavaghe" />
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">مبلغ جریمه</span><br />
            <span class="text-danger" dir="rtl">{{ list.wwwJarime == null ? 0 : $Comma3ragham(list.wwwJarime) }}</span>
          </div>
          <div class="col-6 mt-md-0 mt-2 text-center col-md-2" dir="rtl">
            <span class="text-secondary">جمع مبلغ قسط</span><br />

            <span v-if="$store.state.renderComponent" class="text-success" dir="rtl">{{
              $Comma3ragham(SumSekhavat[list.id] != null ? SumSekhavat[list.id] : Number(list.mablaghGhestVam.replaceAll(",", "")) + Number(list.wwwJarime == null ? 0 : list.wwwJarime))
            }}</span>
          </div>
          <div class="col-12 mt-md-0 mt-2 col-md-2" dir="rtl">
            <!-- <a href="javascript:;"  class="mt-2 badge" @click="DeleteToCart(list.id);$ResetTimer()"><span class="	fa fa-trash-alt text-secondary hover-danger" style="font-size:15px;"></span></a> -->
            <button type="button" class="btn btn-outline-dark mt-3" style="font-size: 14px !important" data-toggle="modal" data-target="#Modal-Orange" dir="ltr" @click="GetTaahodatRizSetId(list)">
              <span class="fa fa-list" tabindex="-1"></span>
            </button>
            <button
              type="button"
              class="btn btn-outline-danger mt-3 mr-1"
              style="font-size: 14px !important"
              @click="
                DeleteToCart(list.id);
                $ResetTimer();
              "
              dir="ltr"
            >
              <span class="fa fa-trash-alt" tabindex="-1"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 text-center mt-2 mb-5">
        <payment v-if="IsCart" @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
          <template v-slot:ContentButtonPayment>
            <button v-if="$store.state.renderComponent" class="btn btn-lg btn-success w-50" tabindex="2" @click="GetMablaghOK()">
              {{ total }}
            </button>
          </template>
        </payment>
      </div>
    </div>
    <div class="row text-right">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-dark active border-none" style="cursor: pointer">
                <input @click="ShowCard(true)" type="radio" name="options" id="option1" autocomplete="off" checked />
                <i class="fas fa-columns"></i> ستونی
              </label>
              <label v-if="$GetIsAnbohSaz() == 'false'" class="btn btn-dark border-none" style="cursor: pointer">
                <input @click="ShowCard(false)" type="radio" name="options" id="option2" autocomplete="off" /><i class="fas fa-list-alt"></i> ردیفی
              </label>
            </div>
            <ul class="nav nav-tabs mt-3 card-header-tabs" id="myTab" role="tablist" dir="rtl">
              <li class="nav-item">
                <a class="nav-link active text-dark" id="Detail-tab" data-toggle="tab" href="#Detailtab" role="tab" aria-controls="Detailtab" aria-selected="true">{{
                  $GetIsAnbohSaz() == "false" ? "تسهیلات خودم" : "پروژه های من"
                }}</a>
              </li>
              <li class="nav-item" v-if="$GetIsAnbohSaz() == 'false'">
                <a class="nav-link text-dark" id="Logo-tab" data-toggle="tab" href="#Logotab" role="tab" aria-controls="Settingtab" aria-selected="true">تسهیلات وابسته</a>
              </li>
            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content text-right p-3" id="Controler">
              <div class="tab-pane fade show active" id="Detailtab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" app id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false">
                          <i class="fas fa-filter"></i> {{ $GetIsAnbohSaz() == "false" ? "فیلتر تسهیلات" : "فیلتر قرارداد ها" }}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(false);
                              $ResetTimer();
                            "
                          >
                            {{ $GetIsAnbohSaz() == "false" ? "تسهیلات دارای بدهی" : "قرارداد های داری بدهی" }}
                            <i v-if="selectedBedehi && selectedAllBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(true);
                              $ResetTimer();
                            "
                          >
                            {{ $GetIsAnbohSaz() == "false" ? "همه تسهیلات" : "همه قرارداد ها" }}
                            <i v-if="selectedAllBedehi && selectedBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                          <!-- <a class="dropdown-item" href="Javascript:;" @click="GetItemCardTaahodatSahebHesab(true);$ResetTimer()">تسهیلات وابسته
                                                        <i v-if="IsTaahodatSahebHesab" class="fas fa-check  text-success  "></i>
                                                    </a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="CardItem && CardItem.length > 0 && IsShowCard == true">
                    <div class="col-md-6" v-for="(item, index) in CardItem" :key="item.Id">
                      <div class="card Netpa-Shadow border-0 mb-3 costom-card" dir="rtl">
                        <div class="row">
                          <div class="text-right col-12">
                            <router-link
                              title="گردش تسهیلات"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaId: item.wwwtblAzaId,
                                },
                              }"
                            >
                              <span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a
                              v-if="$session.get('CustCode') != 868 && $GetIsAnbohSaz() == 'false'"
                              data-toggle="modal"
                              data-target="#Modal-Mobile"
                              @click="OpenDetail(index)"
                              title="جزئیات تسهیلات"
                              ><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span
                            ></a>
                            <a
                              v-if="$session.get('CustCode') == 868"
                              data-toggle="modal"
                              data-target="#Modal-Mobile"
                              @click="OpenDetail(index)"
                              title="جزئیات تسهیلات"
                              class="Pointer mr-2 badge badge-info text-light font-weight-normal px-2 py-1"
                              >جزئیات تسهیلات</a
                            >

                            <a
                              href="javascript:;"
                              class="badge"
                              title="افزودن به لیست پرداخت"
                              @click="AddToCart(item, false)"
                              :class="item.mande.replaceAll(',', '') + Number(item.wwwJarime) - item.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'd-none'"
                            >
                              <i class="fas fa-cart-plus text-succes" style="font-size: 15px"></i
                            ></a>
                            <span class="badge badge-primary font-weight-normal float-left Pointer px-2 py-1" @click="DownloadFishVariz(item)" v-if="$session.get('CustCode') == '945'">
                              <i class="fas fa-receipt" style="font-size: 13px"></i>
                              <span class="mr-2" style="font-size: 11px"> دانلود فیش</span>
                            </span>
                            <hr />
                          </div>
                          <div class="col-md-7 text-right">
                            <div class="form-inlin">
                              <div class="form-group mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold"> {{ $GetIsAnbohSaz() == "false" ? "نوع تسهیلات :" : "نوع قرارداد :" }} </label>
                                <span class="text-right font-weight-bold text-dark fl">
                                  {{ item.desNoe }}
                                </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold">{{ $GetIsAnbohSaz() == "false" ? " شماره تسهیلات :" : "شماره قرارداد :" }} </label>
                                <span dir="rtl" class="text-right font-weight-bold text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblDate" class="text-right font-weight-bold"> تاریخ شروع اقساط : </label>
                                <span class="text-right font-weight-bold text-dark fl">{{ item.tarixShoroAghsat }} </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold">{{ $GetIsAnbohSaz() == "false" ? " مبلغ تسهیلات :" : "مبلغ واحد :" }} </label>
                                <span class="text-right font-weight-bold text-dark fl">{{ $Comma3ragham(item.mablaghVam) }} </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblshenaseVariz" class="text-right font-weight-bold"> شناسه واریز : </label>
                                <span class="text-right font-weight-bold text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblMabSharj" class="text-right text-danger font-weight-bold"> مجموع معوق : </label>
                                <i
                                  v-if="Number(item.sumMabMoavaghe.replace(/,/g, '').replace(/\./g, '')) > 0 && ($session.get('CustCode') == 945 || $session.get('CustCode') == 8002)"
                                  class="fas fa-info-circle text-warning Pointer"
                                  title="جزئیات معوقات"
                                  data-toggle="modal"
                                  data-target="#ModalBanafash"
                                  @click="
                                    TaahodatIdForCardex = item.id;
                                    wwwtblAzaIdForCardex = item.wwwtblAzaId;
                                  "
                                ></i>
                                <span class="text-right font-weight-bold text-danger fl">{{ $Comma3ragham(item.sumMabMoavaghe) == "null" ? "-" : $Comma3ragham(item.sumMabMoavaghe) }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-12 text-center">

                            <div class="row text-right">
                              <div class="col-12">
                                <label for="lblMabGhest" class="text-right font-weight-bold no-wrap"> مبلغ قسط : </label>
                              </div>
                              <div class="col-12">
                                <span class="text-right font-weight-bold no-wrap text-dark fl"
                                  >{{ $Comma3ragham(item.mablaghGhestVam) }}
                                </span>
                              </div>
                            </div>
                            <hr />
                            <div class="row text-right mb-2">
                              <div class="col-12">
                                <label for="lblGhabelBardasht" class="text-right font-weight-bold no-wrap"> {{ $GetIsAnbohSaz() == "false" ? "مانده تسهیلات" : "مانده قرارداد" }} : </label>
                              </div>
                              <div class="col-12">
                                <span class="text-right font-weight-bold no-wrap text-dark fl">
                                  {{ $Comma3ragham(Number(item.ghabelBardasht.replaceAll(",", ""))) }}
                                </span>
                              </div>
                            </div>
                            <hr />


                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu">
                            <a
                              @click="Deposit(item, tasveye(item.id))"
                              :class="item.mande.replaceAll(',', '') + Number(item.wwwJarime) - item.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'disabled'"
                              class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                              >پرداخت</a
                            >
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              :to="{
                                name: 'LoanCardex',
                                params: { TaahodatId: item.id, wwwtblAzaId: item.wwwtblAzaId },
                              }"
                              :class="item.mande.replaceAll(',', '') > 0 ? '' : 'disabled'"
                              class="btn btn-outline-warning custom-class NetPa-btn mb-1 w-100 no-wrap"
                            >
                              {{ $GetIsAnbohSaz() == "false" ? "کاردکس" : "کاردکس اقساط" }}
                            </router-link>
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              title="گردش تسهیلات"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaId: item.wwwtblAzaId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                            >
                              {{ $GetIsAnbohSaz() == "false" ? "گردش" : "گردش حساب من" }}
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows" :columns="columns" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <div class="col-xl-6 col-12">
                              <a
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu"
                                @click="Deposit(props.row, tasveye(props.row.id))"
                                :class="props.row.mande.replaceAll(',', '') + Number(props.row.wwwJarime) - props.row.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'disabled'"
                                class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                                >پرداخت</a
                              >
                            </div>
                            <div class="col-xl-6 col-12">
                              <a
                                href="javascript:;"
                                title="افزودن به لیست پرداخت"
                                @click="AddToCart(props.row, false)"
                                :class="props.row.mande.replaceAll(',', '') + Number(props.row.wwwJarime) - props.row.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'd-none'"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                              >
                                <i class="fas fa-cart-plus text-succes" style="font-size: 15px"></i>افزودن</a
                              >
                            </div>
                            <div class="col-xl-6 col-12">
                              <router-link
                                title="گردش تسهیلات"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                    wwwtblAzaId: props.row.wwwtblAzaId,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <div class="col-xl-6 col-12">
                              <router-link
                                :to="{
                                  name: 'LoanCardex',
                                  params: { TaahodatId: props.row.id, wwwtblAzaId: props.row.wwwtblAzaId },
                                }"
                                :class="props.row.mande.replaceAll(',', '') > 0 ? '' : 'disabled'"
                                class="btn btn-outline-warning custom-class NetPa-btn mb-1 text-dark w-100 no-wrap"
                              >
                                کاردکس</router-link
                              >
                            </div>
                          </div>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Logotab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row">
                    <div class="col-md-2 col-12">
                      <div class="dropdown">
                        <button class="btn btn-dark border border-dark rounded dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-expanded="false">
                          <i class="fas fa-filter"></i>تسهیلات وابسته
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            v-for="item in groupBy"
                            :key="item.wwwtblAzaId"
                            :id="item.wwwtblAzaId"
                            @click="
                              GetSahebHesab(item.wwwtblAzaId, false);
                              $ResetTimer();
                            "
                          >
                            {{ item.nameFamily }}</a
                          >
                          <hr />

                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetSahebHesab(0, true);
                              $ResetTimer();
                            "
                            >همه تسهيلات وابسته
                            <i class="fas fa-check text-success"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="col-12">
                      <div class="alert alert-warning w-100 text-center">در حال حاضر تسهیلات وابسته شما صفر میباشد</div>
                    </div>
                  </div>
                  <div class="row" v-if="FilterCardItemTaahodatSahebHesab && FilterCardItemTaahodatSahebHesab.length > 0 && IsTaahodatSahebHesab == true && IsShowCard == true">
                    <div class="col-md-6" v-for="(item, index) in FilterCardItemTaahodatSahebHesab" :key="item.Id">
                      <div class="card border-0 mb-3 costom-card-sahebanhesab" dir="rtl">
                        <div class="row">
                          <div class="text-right col-12">
                            <router-link
                              title="گردش تسهیلات"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaId: item.wwwtblAzaId,
                                },
                              }"
                            >
                              <span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetailSahebanHesab(index)" title="جزئیات حساب"
                              ><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span
                            ></a>

                            <a
                              href="javascript:;"
                              class="badge"
                              title="افزودن به لیست پرداخت"
                              @click="AddToCart(item, false)"
                              :class="item.mande.replaceAll(',', '') + Number(item.wwwJarime) - item.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'd-none'"
                            >
                              <i class="fas fa-cart-plus text-succes" style="font-size: 15px"></i
                            ></a>

                            <small class="text-dark float-left ml-3"
                              ><span class="fas fa-user text-success" style="font-size: 15px"></span>
                              {{ item.nameFamily }}
                            </small>
                            <hr />
                          </div>
                          <div class="col-md-7 text-right">
                            <div class="form-inlin">
                              <div class="form-group mb-2">
                                <label for="lblNoeHesab" class="text-right font-weight-bold"> نوع تسهیلات : </label>
                                <span class="text-right font-weight-bold text-dark fl">
                                  {{ item.desNoe }}
                                </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblVcode" class="text-right font-weight-bold"> شماره تسهیلات : </label>
                                <span dir="rtl" class="text-right font-weight-bold text-dark fl">
                                  {{ item.vCode }}
                                </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblDate" class="text-right font-weight-bold"> تاریخ شروع اقساط : </label>
                                <span class="text-right font-weight-bold text-dark fl">{{ item.tarixShoroAghsat }} </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblMabSharj" class="text-right font-weight-bold"> مبلغ تسهیلات : </label>
                                <span class="text-right font-weight-bold text-dark fl">{{ $Comma3ragham(item.mablaghVam) }} </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblshenaseVariz" class="text-right font-weight-bold"> شناسه واریز : </label>
                                <span class="text-right font-weight-bold text-dark fl">{{ item.shenaseVariz }} </span>
                              </div>
                              <div class="form-group mb-2">
                                <label for="lblMabSharj" class="text-right text-danger font-weight-bold"> مجموع معوق : </label>
                                <span class="text-right font-weight-bold text-danger fl">{{ $Comma3ragham(item.sumMabMoavaghe) == "null" ? "-" : $Comma3ragham(item.sumMabMoavaghe) }} </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-5 col-12 text-center">
                            <div class="">
                              <p class="text-center m-0">مبلغ قسط</p>
                              <small class="card-text">{{ $Comma3ragham(item.mablaghGhestVam) }}</small>
                              <hr />
                              <p class="text-center m-0">مانده تسهیلات</p>
                              <small class="card-text">{{ $Comma3ragham(Number(item.mande.replaceAll(",", "")) - Number(item.sumMabTaeedNaShode.replaceAll(",", ""))) }}</small>
                              <hr />
                            </div>
                          </div>
                        </div>
                        <div class="row mt-1">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu">
                            <a
                              @click="Deposit(item, tasveye(item.id))"
                              :class="item.mande.replaceAll(',', '') + Number(item.wwwJarime) - item.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'disabled'"
                              class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                              >پرداخت</a
                            >
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              :to="{ name: 'LoanCardex', params: { TaahodatId: item.id, wwwtblAzaId: item.wwwtblAzaId } }"
                              :class="item.mande.replaceAll(',', '') > 0 ? '' : 'disabled'"
                              class="btn btn-outline-warning custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >کاردکس</router-link
                            >
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              title="گردش تسهیلات"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaId: item.wwwtblAzaId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                            >
                              گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <vue-bootstrap4-table v-if="IsShowCard == false" :rows="rows2" :columns="columns2" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="row">
                            <div class="col-xl-6 col-12">
                              <a
                                v-if="$session.get('AccessMenu').filter((x) => x.id == 11)[0].isMenu"
                                @click="Deposit(props.row, tasveye(props.row.id))"
                                :class="props.row.mande.replaceAll(',', '') + Number(props.row.wwwJarime) - props.row.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'disabled'"
                                class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                                >پرداخت</a
                              >
                            </div>
                            <div class="col-xl-6 col-12">
                              <a
                                href="javascript:;"
                                title="افزودن به لیست پرداخت"
                                @click="AddToCart(props.row, false)"
                                :class="props.row.mande.replaceAll(',', '') + Number(props.row.wwwJarime) - props.row.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'd-none'"
                                class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap Pointer"
                              >
                                <i class="fas fa-cart-plus text-succes" style="font-size: 15px"></i>افزودن</a
                              >
                            </div>

                            <div class="col-xl-6 col-12">
                              <router-link
                                title="گردش تسهیلات"
                                :to="{
                                  name: 'Turnover',
                                  params: {
                                    TaahodatId: props.row.id,
                                    wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                    wwwtblAzaId: props.row.wwwtblAzaId,
                                  },
                                }"
                                class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              >
                                گردش
                              </router-link>
                            </div>
                            <div class="col-xl-6 col-12">
                              <router-link
                                :to="{
                                  name: 'LoanCardex',
                                  params: { TaahodatId: props.row.id },
                                }"
                                :class="props.row.mande.replaceAll(',', '') - props.row.sumMabTaeedNaShode.replaceAll(',', '') > 0 ? '' : 'disabled'"
                                class="btn btn-outline-warning custom-class NetPa-btn mb-1 w-100 text-dark no-wrap"
                              >
                                کاردکس</router-link
                              >
                            </div>
                          </div>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-custom v-if="$store.state.renderComponent">
      <template v-slot:HeaderModalInfo>
        <span>
          <i class="fas fa-info-circle text-dark mx-2" style="font-size: 16 !important"></i>
          <span style="font-size: 16 !important" class="text-light font-weight-bold">جزئیات حساب</span></span
        >
      </template>
      <template v-slot:ContentModalMobile>
        <div class="container-fluid">
          <div v-if="detailInModal != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right text-peimary" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModal].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع حساب: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره تسهيلات:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ اصل وام :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghVam) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>کارمزد(1):
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghKarmozd1) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع اقساط:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarixShoroAghsat }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ کل وام
              <span class="text-light" style="font-size: 15px !important">
                {{
                  $Comma3ragham(Number(CardItem[detailInModal].mablaghKarmozd1.replace(/,/g, "").replace(/\./g, "")) + Number(CardItem[detailInModal].mablaghVam.replace(/,/g, "").replace(/\./g, "")))
                }}</span
              >
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>موارد مصرف  :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].comment }}</span>
            </div>

            <div class="col-12 border border-bottom mt-4"></div>

            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ قسط :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghGhestVam) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ اولین قسط :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghAvalinGhest) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>سررسید قسط پرداخت نشده :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].minTarGhestBedehkar.replaceAll(/,/g, "") }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ آخرین قسط :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mabLastGhest) }}</span>
            </div>
            <div
              v-if="$session.get('CustCode') == 868 || $session.get('CustCode') == 954 || $session.get('CustCode') == 8002"
              class="col-md-12 col-12 mt-2 text-right mt-2"
              style="font-size: 15px !important"
            >
              <i class="fas fa-square ml-2 text-success"></i>بدهی به شرط تسویه زودتر از موعد :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(tasveye(CardItem[detailInModal].id).mabTasveye) }}</span>
              <a
                v-if="tasveye(CardItem[detailInModal].id).mabTasveye > 0"
                @click="Deposit(CardItem[detailInModal], tasveye(CardItem[detailInModal].id))"
                data-dismiss="modal"
                class="btn btn-outline-warning mr-5 w-25 no-wrap Pointer"
                >تسویه تسهیلات</a
              >
            </div>
            <!-- <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i>شناسه: <span class="text-light" dir="rtl" style="font-size:15px !important"> {{CardItem[detailInModal].tarixShoroAghsat}}</span></div>
                               <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i>شناسه واریز: <span class="text-light" dir="rtl" style="font-size:15px !important"> {{CardItem[detailInModal].tarixShoroAghsat}}</span></div> -->
            <div class="col-6"></div>

            <div class="col-12 border border-bottom mt-4"></div>

            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>تعداد اقساط:
              <span class="text-light" style="font-size: 15px !important"> {{ CardItem[detailInModal].tedadGhestVam }}</span>
            </div>
            <!-- <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مبلغ تسهیلات
              دریافتی:
              <span class="text-light" style="font-size: 15px !important">
                {{ $Comma3ragham(CardItem[detailInModal].mablaghVam) }}</span>
            </div> -->
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>تعداد اقساط پرداخت نشده:<span class="text-light" style="font-size: 15px !important">
                {{ CardItem[detailInModal].tedadAghsatPardaxtNaShode }}</span
              >
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>کارمزد(2):
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghKarmozd2) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>تعداد اقساط پرداخت شده:<span class="text-light" style="font-size: 15px !important">
                {{ CardItem[detailInModal].tedadAghsatPardaxtShode }}</span
              >
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مجموع اقساط پرداخت نشده:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].sumMabBedehi) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> تعداد اقساط معوقه:
              <span class="text-light" style="font-size: 15px !important"> {{ CardItem[detailInModal].tedadMoavaghe }}</span>
            </div>

            <div class="col-12 border border-bottom mt-4"></div>

            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-info"></i>مجموع اقساط پرداخت شده:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].sumMabPar) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-info"></i> مبلغ معوقه:
              <span class="text-light" style="font-size: 15px !important">
                {{ $Comma3ragham(CardItem[detailInModal].sumMabMoavaghe) == "null" ? "-" : $Comma3ragham(CardItem[detailInModal].sumMabMoavaghe) }}</span
              >
            </div>
          </div>
          <div v-if="detailInModalSahebHesab != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right text-peimary" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].desNoe }}
              </h6>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره تسهيلات:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ وام :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghVam) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع اقساط:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarixShoroAghsat }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ قسط :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghGhestVam) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ اولین قسط :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghAvalinGhest) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مبلغ آخرین قسط :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mabLastGhest) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>سررسید اولین بدهی :
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].minTarGhestBedehkar.replaceAll(/,/g, "") }}</span>
            </div>

            <div class="col-6"></div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom mt-2 my-2"></div>
            <div class="col-1 my-2"></div>

            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>تعداد اقساط:
              <span class="text-light" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tedadGhestVam }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مبلغ تسهیلات دریافتی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghVam) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>کارمزد(1):
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghKarmozd1) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>کارمزد(2):
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghKarmozd2) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مجموع اقساط پرداخت شده:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].sumMabPar) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مجموع اقساط پرداخت نشده:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].sumMabBedehi) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>تعداد اقساط پرداخت شده:<span class="text-light" style="font-size: 15px !important">
                {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tedadAghsatPardaxtShode }}</span
              >
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>تعداد اقساط پرداخت نشده:<span class="text-light" style="font-size: 15px !important">
                {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tedadAghsatPardaxtNaShode }}</span
              >
            </div>
            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom mt-2 my-2"></div>
            <div class="col-1 my-2"></div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-info"></i> تعداد اقساط معوقه:
              <span class="text-light" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tedadMoavaghe }}</span>
            </div>
            <div class="col-md-6 col-12 mt-2 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-info"></i> مبلغ معوقه:
              <span class="text-light" style="font-size: 15px !important">
                {{
                  $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].sumMabMoavaghe) == "null" ? "-" : $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].sumMabMoavaghe)
                }}</span
              >
            </div>
          </div>
        </div>
      </template>
      <template v-slot:ContentModalOrange>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="bg-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">تاریخ قسط</th>
                <th scope="col">مبلغ قسط</th>
                <th scope="col">مبلغ جریمه</th>
                <th scope="col">تاریخ سند</th>
                <th scope="col">شماره سند</th>
                <th scope="col">عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(itemRiz, key) in ListTaahodatRiz" :key="itemRiz.id" :class="itemRiz.select == true ? 'bg-success-custom' : ''">
                <th scope="row">{{ key + 1 }}</th>
                <td>{{ itemRiz.tarixGhest }}</td>
                <td>{{ $Comma3ragham(itemRiz.mablaghGhest) }}</td>
                <td>{{ $Comma3ragham(itemRiz.mabJarime) }}</td>
                <td>
                  {{ itemRiz.tarixSanad == null ? "سند ثبت نشده" : itemRiz.tarixSanad }}
                </td>
                <td>
                  {{ itemRiz.shomareSanad == null ? "سند ثبت نشده" : itemRiz.shomareSanad }}
                </td>
                <td>
                  <button
                    type="button"
                    class="badge font-weight-normal px-2 py-1 mr-1 w-100"
                    :class="itemRiz.select == true ? ' btn-outline-orange' : ' btn-outline-success bg-light'"
                    dir="ltr"
                    @click="SelectRiz(itemRiz)"
                  >
                    <span class="mr-2">{{ itemRiz.select == true ? "حذف" : "انتخــاب" }}</span>
                    <span :class="itemRiz.select == true ? 'fa fa-times' : 'fa fa-check'"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <button
            v-if="ListTaahodatRiz != null && ListTaahodatRiz != []"
            type="button"
            class="btn btn-success mr-1"
            dir="ltr"
            :disabled="sumMabRiz <= 0 ? true : false"
            data-dismiss="modal"
            @click="SetMablagh(ListTaahodatRiz[0].wwwtblTaahodatId)"
          >
            <span v-if="sumMabRiz[ListTaahodatRiz[0].wwwtblTaahodatId] > 0">
              تایید مبلغ
              <span class="mr-2">{{ $Comma3ragham(sumMabRiz[ListTaahodatRiz[0].wwwtblTaahodatId]) }}</span>
              {{ $GetVahedPool() }}</span
            >
            <span v-else>لطفا یک یا چند قسط را انتخاب نمایید</span>
          </button>
        </div>
      </template>
      <template v-slot:ContentModalBanafash>
        <loan-cardex :FilterMoavaghe="true" :TaahodatId="TaahodatIdForCardex" :wwwtblAzaId="wwwtblAzaIdForCardex"></loan-cardex>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import Panel from "../Tools/NetPa/Panel.vue";
import Payment from "./Payment.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
import VueBootstrap4Table from "vue-bootstrap4-table";
import loading from "../Tools/NetPa/Loading.vue";
import LoanCardex from "./LoanCardex.vue";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      TableSetting: null,
      wwwtblAzaIdForCardex: null,
      TaahodatIdForCardex: null,
      loadingRender: false,
      CardItem: null,
      CardItemTaahodatSahebHesab: 0,
      FilterCardItemTaahodatSahebHesab: null,
      groupBy: null,
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_CheckUpMande: {
        ArryfildValue: {},
        Method: "Post",
        Action: "CheckUpMande",
        Token: this.$session.get("TokenNetPa"),
      },
      selectedBedehi: true,
      selectedAllBedehi: false,
      CartValue: [],
      IsCart: false,
      // SumMablagh: 0,
      GatewayCode: null,
      detailInModal: null,
      FixVariz: false,
      ListTaahodatRiz: null,
      CountSelectedTaahodatRiz: 0,
      CountSelectedTaahodatRizMovaghat: 0,
      sumMabRiz: {},
      SumSekhavat: {},
      totla: 0,
      IsTaahodatSahebHesab: false,
      detailInModalSahebHesab: null,
      IsShowCard: true,
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره ",
          name: "vCode",
        },
        {
          label: " شروع اقساط ",
          name: "tarixShoroAghsat",
        },
        {
          label: "مبلغ تسهیلات",
          name: "mablaghVam",
        },
        {
          label: "شناسه واریز",
          name: "shenaseVariz",
        },
        {
          label: "مجموع معوق",
          name: "sumMabMoavaghe",
        },
        {
          label: "مبلغ قسط",
          name: "mablaghGhestVam",
        },
        {
          label: "مانده تسهیلات",
          name: "NewMande",
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "نوع",
          name: "desNoe",
        },
        {
          label: "شماره ",
          name: "vCode",
        },
        {
          label: "مشخصات",
          name: "nameFamily",
        },
        {
          label: " شروع اقساط ",
          name: "tarixShoroAghsat",
        },
        {
          label: "مبلغ تسهیلات",
          name: "mablaghVam",
        },
        {
          label: "شناسه واریز",
          name: "shenaseVariz",
        },
        {
          label: "مجموع معوق",
          name: "sumMabMoavaghe",
        },
        {
          label: "مبلغ قسط",
          name: "mablaghGhestVam",
        },
        {
          label: "مانده تسهیلات",
          name: "NewMande",
        },
        {
          label: "عملیات ها",
          name: "id",
          slot_name: "action-slot",
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table-bordered table-striped  ",
      },

      DataAxiosRowCart: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesabCart: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },

      LoanList: [],
      ChildsLoanList: [],
      mabTasveye: {},
    };
  },
  components: {
    Panel,
    Payment,
    ModalCustom,
    VueBootstrap4Table,
    loading,
    LoanCardex,
  },
  computed: {
    GetMablagh() {
      var mab = 0;
      for (let index = 0; index < this.CartValue.length; index++) {
        if (this.SumSekhavat[this.CartValue[index].id]) {
          mab = mab + Number(this.SumSekhavat[this.CartValue[index].id]);
        } else {
          mab += Number(this.CartValue[index].mablaghGhestVam) + Number(this.CartValue[index].wwwJarime == null ? 0 : this.CartValue[index].wwwJarime);
        }
      }
      mab = mab / 10;
      return " پرداخت " + this.$Comma3ragham(mab) + " تومان ";
    },
  },
  mounted() {
    this.GetItemCard(false);
    // this.GetTaahodatSahebHesab(false)
    // this.GetTaahodat(false)
    var a = document.getElementById("dropdownMenuButton");
    a.click();
    this.GetItemCardTaahodatSahebHesab();
    this.GetTableBank();
  },

  methods: {
    tasveye(val) {
      this.$GetTasveye(val, this.$session.get("UserInfoNetPa").wwwtblShobeId).then((data) => {
        this.mabTasveye = data;
      });
      return this.mabTasveye;
    },
    ShowCard(status) {
      this.IsShowCard = status;
    },
    GetMablaghs() {
      var mab = 0;
      for (let index = 0; index < this.CartValue.length; index++) {
        if (this.SumSekhavat[this.CartValue[index].id]) {
          mab = mab + Number(this.SumSekhavat[this.CartValue[index].id]);
        } else {
          mab += Number(this.CartValue[index].mablaghGhestVam.replaceAll(",", "")) + Number(this.CartValue[index].wwwJarime == null ? 0 : this.CartValue[index].wwwJarime);
        }
      }
      mab = mab / 10;

      return " پرداخت " + this.$Comma3ragham(mab) + " تومان ";
    },
    GetSahebHesab(id, IsAll) {
      let info;
      let list = [];
      if (IsAll) {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab;
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] = this.FilterCardItemTaahodatSahebHesab[index].mande - this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode;
          info["NewghabelBardasht"] = this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht;
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      } else {
        this.IsTaahodatSahebHesab = true;
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id);
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index];
          info["NewMande"] = this.FilterCardItemTaahodatSahebHesab[index].mande - this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode;
          info["NewghabelBardasht"] = this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht;
          list.push(info);
        }
        this.rows2 = this.$FormatMablaghGrid(list);
      }
    },
    GetItemCard(IsAll) {
              

      let info;
      let list = [];
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        //console.log('*//**//*/*',data);
        this.EditRowsLoan(data);
        if (IsAll) {
        
          this.CardItem = data;
          this.selectedBedehi = false;
          this.selectedAllBedehi = true;

          for (let index = 0; index < data.length; index++) {
            info = data[index];
            info["NewMande"] = data[index].mande - data[index].sumMabTaeedNaShode;
            list.push(info);
          }
          this.rows = this.$FormatMablaghGrid(list);
        } else {
          this.CardItem = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0);

          this.selectedBedehi = true;
          this.selectedAllBedehi = false;
          for (let index = 0; index < data.length; index++) {
            info = data[index];
            info["NewMande"] = data[index].mande - data[index].sumMabTaeedNaShode;
            list.push(info);
          }
          this.rows = this.$FormatMablaghGrid(list.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0));
        }
        // console.log(this.CardItem);
      });
    },
    GetItemCardTaahodatSahebHesab() {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append("wwwtblSarfaslTypeId", 1);
      this.DataAxios_SahebHesab.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          this.EditRowsLoan(data);
          this.CardItemTaahodatSahebHesab = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0);
          var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
            if (!unique.some((obj) => obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value)) {
              unique.push(o);
            }
            return unique;
          }, []);
          this.groupBy = result;
        })
        .finally(() => {
          if (this.$session.get("UserFromLoan")) {
            if (this.$session.get("UserFromLoan")[1] == true) {
              if (this.$session.get("UserFromLoan")[0] != this.$session.get("UserInfoNetPa").wwwtblAzaId) {
                document.getElementById("Logo-tab").click();
                document.getElementById(this.$session.get("UserFromLoan")[0]).click();
                this.$session.remove("UserFromLoan");
              }
            }
          }
          this.loadingRender = false;
        });
    },
    DeleteToCart(id) {
      var a = this.CartValue.map(function (item) {
        return item.id;
      }).indexOf(id);
      this.CartValue.splice(a, 1);

      if (this.CartValue.length == 0) {
        this.IsCart = false;
      }
      this.total = this.GetMablaghs();
    },
    GetMablaghOK() {
      var mab = 0;
      for (let index = 0; index < this.CartValue.length; index++) {
        if (this.SumSekhavat[this.CartValue[index].id]) {
          mab = mab + Number(this.SumSekhavat[this.CartValue[index].id]);
        } else {
          mab += Number(this.CartValue[index].mablaghGhestVam.replaceAll(",", "")) + Number(this.CartValue[index].wwwJarime == null ? 0 : this.CartValue[index].wwwJarime);
        }
      }
      const WwwtblVarizGorohiRiz = [];
      for (let index = 0; index < this.CartValue.length; index++) {
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.CartValue[index].id,
          Mablagh: Number(this.CartValue[index].mablaghGhestVam.replaceAll(",", "")),
          SharhRiz: " پرداخت قسط تسهیلات " + this.CartValue[index].vCode,
          WwwtblAzaId: this.CartValue[index].wwwtblAzaId,
          BnpCashDBtblTaahodatId: this.CartValue[index].bnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.CartValue[index].bnpCashDBtblAzaId,
          MablaghJarime: this.CartValue[index].wwwJarime == null ? 0 : this.CartValue[index].wwwJarime,
          TarixGhest: this.CartValue[index].minTarGhestBedehkar,
        });
      }
      this.SumMablagh = mab;
      this.DataAxios_Variz.ArryfildValue.Mablagh = this.SumMablagh;
      this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
      this.DataAxios_Variz.ArryfildValue.Sharh = "پرداخت اقساط گروهی";
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate;
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get("UserInfoNetPa").custCode);
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.$session.get("UserInfoNetPa").wwwtblAzaId;
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz;
      this.$PostData(this.DataAxios_Variz).then((result) => {
        this.$Payment(
          this.GatewayCode + "",
          JSON.stringify(this.SumMablagh),
          this.$session.get("UserInfoNetPa").ozvName + " " + this.$session.get("UserInfoNetPa").ozvFamily,
          this.$session.get("UserInfoNetPa").email,
          this.$session.get("UserInfoNetPa").mobile,
          WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
          "",
          this.CartValue[0].vCode,
          "سبد اقساط",
          JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
          this.$session.get("UserInfoNetPa").custCode,
          JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
          result.idRepoMaster,
          this.$session.get("UserInfoNetPa").codeMeli
        );
      });
    },
    Deposit(item, mabTasveyeZodtar) {
      const formData = new FormData();
      formData.append("wwwtblTaahodatId", item.id);
      this.DataAxios_CheckUpMande.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_CheckUpMande).then((data) => {});

      this.$router.push({
        name: "Deposit",
        params: {
          TaahodatItem: item,
          IsTashilat: true,
          wwwtblAzaId: item.wwwtblAzaId,
          mabTasveyeZodtar: mabTasveyeZodtar.mabTasveye ? mabTasveyeZodtar.mabTasveye : 0,
          mabReturnrKarmozd: mabTasveyeZodtar.sumKarmozd ? mabTasveyeZodtar.sumKarmozd : 0,
        },
      });
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val;
    },
    FixVarizGhest(val) {
      this.FixVariz = val;
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null;
      this.detailInModal = index;
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null;
      this.detailInModalSahebHesab = index;
    },
    GetTaahodatRizSetId(taahodat) {
      this.GetTaahodatRiz(taahodat.id);
      this.Alaki = taahodat;
    },
    SelectRiz(itemRiz) {
      if (itemRiz.shomareSanad == null || itemRiz.tarixSanad == null) {
        itemRiz.select = !itemRiz.select;
        let ItemMab = itemRiz.mablaghGhest;
        if (!this.sumMabRiz[itemRiz.wwwtblTaahodatId]) {
          this.sumMabRiz[itemRiz.wwwtblTaahodatId] = 0;
        }
        if (itemRiz.select) {
          this.CountSelectedTaahodatRizMovaghat += 1;
          this.sumMabRiz[itemRiz.wwwtblTaahodatId] = this.sumMabRiz[itemRiz.wwwtblTaahodatId] + ItemMab;
        } else {
          if (this.CountSelectedTaahodatRiz > 0) {
            this.CountSelectedTaahodatRizMovaghat -= 1;
          }
          this.sumMabRiz[itemRiz.wwwtblTaahodatId] = this.sumMabRiz[itemRiz.wwwtblTaahodatId] - ItemMab;
        }
      } else {
        this.$mySweetDefaultTost("عدم انتخاب", "قسط انتخابی شما ثبت سند شده ، لطفا قسط دیگیری را انتخاب کنید", "warning", 3000);
      }
    },
    SetMablagh(taahodid) {
      this.CountSelectedTaahodatRiz = this.CountSelectedTaahodatRizMovaghat;
      if (this.$session.get("UserInfoNetPa").cId == "801" || this.$session.get("UserInfoNetPa").cId == "7777") {
        if (this.CountSelectedTaahodatRiz <= 1) {
          this.SumSekhavat[taahodid] = this.sumMabRiz[taahodid] + this.TahoodSelected.wwwJarime + "";
        } else {
          this.SumSekhavat[taahodid] = this.sumMabRiz[taahodid] + "";
        }
      } else {
        this.Mablagh = this.sumMabRiz[taahodid] + this.TahoodSelected.wwwJarime + "";
      }
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
      this.total = this.GetMablaghs();
    },

    GetTaahodat(IsAccount) {
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      if (IsAccount == true) formData.append("wwwtblSarfaslTypeId", 2);
      else formData.append("wwwtblSarfaslTypeId", 1);

      this.DataAxiosRowCart.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRowCart).then((data) => {
        
        if (IsAccount) {
          this.AccountList = data.filter((x) => x.mande > 0);
          this.EditRowsAccount(this.AccountList);
        } else {
          this.LoanList = data.filter((x) => x.mande > 0);
          this.EditRowsLoan(this.LoanList);
          this.SumGhabelParLoan(this.LoanList);
        }
      });
    },
    GetTaahodatSahebHesab(IsAccount) {
      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      if (IsAccount == true) formData.append("wwwtblSarfaslTypeId", 2);
      else formData.append("wwwtblSarfaslTypeId", 1);

      this.DataAxios_SahebHesabCart.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_SahebHesabCart).then((data) => {
        if (IsAccount) {
          this.ChildsAccountList = data.filter((x) => x.mande > 0);
          this.EditRowsAccount(this.ChildsAccountList);
        } else {
          this.ChildsLoanList = data.filter((x) => x.mande + x.wwwJarime - x.sumMabTaeedNaShode > 0);
          this.EditRowsLoan(this.ChildsLoanList);
          this.SumGhabelParChildLoan(this.ChildsLoanList);
        }
        this.loadingRender = false;
      });
    },
    AddToCart(row, IsAccount) {
      if (IsAccount == true) {
        if (row.MabVarizi > 0) {
          row.SumGhabelPar = Number(row.MabVarizi);
          this.$Netpa_AddToCart(row, "Account", "حساب ها");
        } else {
          this.$mySweetDefaultTost("مبلغ واریزی غیر مجاز", "مبلغ واریزی خالی می باشد لطفا مبلغ واریزی را تکمیل و سپس دوباره تلاش کنید", "warning", 3000);
        }
      }
      if (IsAccount == false) {
        // row.SumGhabelPar=Number(row.SumGhabelPar)
        // this.SumJarimeAndMablaghGhestVam(row);
        this.$Netpa_AddToCart(row, "Loan", "تسهیلات");
      }
    },
    EditRowsLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        // if (listRow[index].sumMabMoavaghe -listRow[index].sumMabTaeedNaShode >0) {
        //      listRow[index].SumGhabelPar=(Number(listRow[index].sumMabMoavaghe)-Number(listRow[index].sumMabTaeedNaShode))+Number(listRow[index].wwwJarime==null?0:listRow[index].wwwJarime);

        // }
        // else if((listRow[index].mabAvalinForPar +listRow[index].sumMabMoavaghe) -listRow[index].sumMabTaeedNaShode >0){
        //       listRow[index].SumGhabelPar=((listRow[index].mabAvalinForPar +listRow[index].sumMabMoavaghe)-listRow[index].sumMabTaeedNaShode)+Number(listRow[index].wwwJarime==null?0:listRow[index].wwwJarime);
        // }
        // else{
        //      listRow[index].SumGhabelPar=Number(listRow[index].mablaghGhestVam)+Number(listRow[index].wwwJarime==null?0:listRow[index].wwwJarime);

        // }
        listRow[index].SumGhabelPar = listRow[index].sumGhabelPar;
      }
    },
    SumJarimeAndMablaghGhestVam(row) {
      row.mablaghGhestVam = Number(row.mablaghGhestVam) + Number(row.wwwJarime == null ? 0 : row.wwwJarime);
    },
    GetTaahodatRiz(row, IsChild) {
      this.TaahodatIdForGetRiz = row.id;

      this.IsChild = IsChild;

      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
    },
    SumMablagh(val) {
      if (this.IsChild == true) {
        for (let index = 0; index < this.ChildsLoanList.length; index++) {
          if (this.ChildsLoanList[index].id == this.TaahodatIdForGetRiz) {
            this.ChildsLoanList[index].SumGhabelPar = val + Number(this.ChildsLoanList[index].wwwJarime == null ? 0 : this.ChildsLoanList[index].wwwJarime);
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          }
        }
      } else {
        for (let index = 0; index < this.LoanList.length; index++) {
          if (this.LoanList[index].id == this.TaahodatIdForGetRiz) {
            this.LoanList[index].SumGhabelPar = Number(val) + Number(this.LoanList[index].wwwJarime == null ? 0 : this.LoanList[index].wwwJarime);

            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true;
            });
          }
        }
      }
    },
    AllAddToCart(Arr) {
      for (let index = 0; index < Arr.length; index++) {
        this.$Netpa_AddToCart(Arr[index], "Loan", "تسهیلات");
      }
    },
    SumGhabelParLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParLoan += listRow[index].SumGhabelPar;
      }
    },
    SumGhabelParChildLoan(listRow) {
      for (let index = 0; index < listRow.length; index++) {
        this.SumAllGhabelParChildLoan += listRow[index].SumGhabelPar;
      }
    },
    DownloadFishVariz(row) {
      var html = `
                <div class="container mt-4 " style="border: 2px dashed #115eab">
                  <div class="row py-2 mt-3" style="border-bottom: 2px dashed #bfd9f2">
                    <div class="col-6 text-center">
                      <h5 class="text-dark">اطلاعات حساب</h5>
                    </div>
                    <div class="col-6 text-center">
                      <h5 class="text-dark">اطلاعات قرداد</h5>
                    </div>
                  </div>
                  <div class="row mt-4 mb-1">
                    <div class="col-6 text-center px-4"  style="border-left: 2px dashed #bfd9f2">
                      <h6 class=""><span class="text-dark">اطلاعات بانک:</span>&nbsp;&nbsp;<span>  ${this.TableSetting.bankName} </span></h6>
                      <h6 class=""><span class="text-dark">شماره حساب:</span>&nbsp;&nbsp;<span>  ${this.TableSetting.hesabNo}  </span></h6>
                      <h6 class=""><span class="text-dark">شماره شبا:</span>&nbsp;&nbsp;<span>  ${this.TableSetting.shebaNo}  </span></h6>
                      <h6 class=""><span class="text-dark" dir="ltr">شماره کارت:</span>&nbsp;&nbsp;<span>  ${this.TableSetting.cardNo.match(/.{1,4}/g).join("-")}  </span></h6>
                      <h6 class=""><span class="text-dark">اطلاعات حساب:</span>&nbsp;&nbsp;<span>  ${this.TableSetting.bankDetail} </span></h6>
                    </div>
                    <div class="col-6 text-center px-4">
                      <h6 class=""><span class="text-dark">نام قرارداد:</span>&nbsp;&nbsp;<span>  ${row.desNoe} </span></h6>
                      <h6 class=""><span class="text-dark">شماره قرارداد:</span>&nbsp;&nbsp;<span dir="ltr">  ${row.vCode}  </span></h6>
                      <h6 class=""><span class="text-dark">شناسه واریز:</span>&nbsp;&nbsp;<span> ${row.shenaseVariz}  </span></h6>
                      <h6 class=""><span class="text-dark">مبلغ :</span>&nbsp;&nbsp;<span>  ${this.$Comma3ragham(row.SumGhabelPar)}  ریال</span></h6>
                    </div>
                  </div>
                </div>
      `;
      var htmlObject = document.createElement("div");
      htmlObject.innerHTML = html;
      html2pdf(htmlObject, {
        jsPDF: { format: "a5", orientation: "landscape" },
      });
    },
    // GetTableSetting(){
    //   var DataAxios_Get = {
    //     ArryfildValue: '',
    //     Method: 'Get',
    //     Action: 'Setting',
    //     Token: this.$session.get('TokenNetPa'),
    //   }
    //   this.$GetData_Body(DataAxios_Get).then((res)=>{
    //     this.TableSetting=res

    //   })
    // }
    GetTableBank() {
      var DataAxios_Get = {
        ArryfildValue: "",
        Method: "Get",
        Action: "Bank/GetBankList",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$GetData_Body(DataAxios_Get).then((res) => {
        res.forEach((bank) => {
          if (bank.shebaNo != null && bank.hesabNo != null && bank.bankDetail != null) {
            this.TableSetting = bank;
            return;
          }
        });
      });
    },
  },
  updated() {
    this.GetMablaghs();
  },
};
</script>
<style scoped>
td,
th {
  white-space: normal !important;
}

.fl {
  float: left !important;
}

.border-line {
  border-right: 1px solid #bdbdbd;
  text-align: center;
}

.costom-card {
  padding: 20px 40px 20px 20px;
  border-radius: 30px;
  /* box-shadow: 0px 4px 8px 0px #435ebe; */
  margin-top: 20px;
  margin-bottom: 50px;
}

.costom-card-sahebanhesab {
  padding: 20px 40px 20px 20px;
  border-radius: 30px;
  box-shadow: 0px 4px 8px 0px #f86c6c;
  margin-top: 20px;
  margin-bottom: 50px;
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.bg-dark-Custom {
  background: #2a3f54 !important;
  /* border:1px solid #2A3F54 !important; */
}

.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}

.btn-outline-orange {
  background: #fff;
}

.bg-success-custom {
  background: #d1bd9e !important;
}

.btn-outline-success {
  background: #ffffff !important;
}

.btn-outline-success:hover {
  background: #5ea31e !important;
  color: #fff;
}
</style>
